import { render, staticRenderFns } from "./evaluations-review.vue?vue&type=template&id=44fbaf4e&"
import script from "./evaluations-review.vue?vue&type=script&lang=js&"
export * from "./evaluations-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports